import React from 'react';
import Ellipsis from '../../images/ellipsis.svg';
import Share from '../../images/share.svg';

const HelpPage = () => (
	<>
	<section className='help'>
		<div className='wrapper'>
			<h2 style={{ textAlign: 'center' }}>Add the app to your phone <span style={{ whiteSpace: "nowrap" }}>or tablet</span></h2>

			<h3>Safari for Apple iOS</h3>

			<p>Add the app&rsquo;s icon to your home screen to find CabinTime quickly, every night!  On an Apple iOS device:</p>

			<ol>
				<li>Open the Safari app.</li>
				<li>Open <strong>CabinTime.org</strong>.</li>
				<li>Click the Share Menu icon (
					<img src={Share} style={{ width: "17px", padding: "0 2px", transform: "translateY(2.5px)", display: "inline-block" }} alt="share icon" />
				).</li>
				<li>Select &ldquo;Add to Home Screen&rdquo; and follow the instructions given.</li>
			</ol>

			<h3>Google Chrome for Android</h3>

			<p>Add the app&rsquo;s icon to your home screen to find CabinTime quickly, every night! On Google Chrome with an Android device:</p>

			<p>Visit <strong>CabinTime.org</strong> on Google Chrome using a phone or tablet. Your first time, you should be prompted to add it to your home screen. Click the prompt to add the app&rsquo;s icon. This will give you easy access to CabinTime.</p>

			<p>If you do not get this prompt using Chrome, follow the instructions below.</p>

			<ol>
				<li>Open the Chrome app.</li>
				<li>Open <strong>CabinTime.org</strong>.</li>
				<li>Choose the menu icon (
					<img src={Ellipsis} style={{ height: "15px", padding: "0 3px", transform: "translateY(2.5px)", display: "inline-block" }} alt="menu icon" />
				) and then, &ldquo;Install app.&rdquo;</li>
			</ol>
		</div>
	</section>

	<footer className='help-page'>
		<div>
			<p className='home'><a href='/'>Return home</a></p>
		</div>
	</footer>
	</>
);

export default HelpPage;